// Material UI
import { Grid, Chip, Icon } from '@mui/material';

// Componentes
import BasicSelect from '@components/Selects/BasicSelect';
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

const EmploymentForm = (props) => {
  const { catalogs, isLoading, formik, showChip = true } = props;

  const getFormik = (value) => getFormikUtil(formik, 'employment', value);

  const isOtro = getFormik('idWork')?.value === 0;

  return (
    <Grid container spacing={3}>
      {showChip && (
        <Grid item xs={12}>
          <Chip icon={<Icon>badge</Icon>} label="Experiencia Laboral" />
        </Grid>
      )}

      <Grid item xs={12} sm={5} md={6} lg={isOtro ? 4 : 6}>
        <BasicSelect
          size="small"
          name="employment.idWork"
          label="¿Ocupación actual? *"
          options={
            catalogs.ocupacion_laboral?.length
              ? [...catalogs.ocupacion_laboral, { value: 0, label: 'OTRA' }]
              : [{ value: 0, label: 'OTRA' }]
          }
          value={getFormik('idWork')?.value}
          onChange={formik.handleChange}
          isLoading={isLoading}
          error={getFormik('idWork').error}
          errorMessage={getFormik('idWork').helperText}
          sx={{ width: '100%' }}
        />
      </Grid>

      {isOtro && (
        <Grid item xs={12} sm={7} md={6} lg={4}>
          <TextFieldTK
            required
            fullWidth
            name="employment.occupation"
            label="Ocupación actual"
            placeholder="Escribe tu ocupación actual"
            value={getFormik('occupation')?.value}
            onChange={formik.handleChange}
            disabled={isLoading}
            error={getFormik('occupation')?.error}
            helperText={getFormik('occupation')?.helperText}
            useTrim
          />
        </Grid>
      )}

      <Grid item xs={12} sm={isOtro ? 12 : 7} md={isOtro ? 12 : 6} lg={isOtro ? 4 : 6}>
        <TextFieldTK
          fullWidth
          name="employment.workplace"
          label="¿Lugar de Trabajo?"
          placeholder=""
          value={getFormik('workplace')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('workplace')?.error}
          helperText={getFormik('workplace')?.helperText}
          useTrim
        />
      </Grid>
    </Grid>
  );
};

export default EmploymentForm;
